// @flow
import React from 'react';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import api from 'utils/API';
import PostCommentsItem from 'app/components/PostCommentsItem';
import {hasPermission} from 'utils/CurrentUser';
import Button from 'app/components/Button';
import styles from './PostComments.styles.js';

class PostComments extends React.Component<Props> {

  unmounted = false;
  hasApprovalPermission = false;

  constructor(props) {
    super(props);

    this.state = {
      list: [],
      page: 0,
      isLastPage: true,
    };
  }

  fetch = (continues = true) => {
    const url = `/comment/${this.props.postId}`;
    const page = continues ? this.state.page + 1 : 1;
    const data = {page};
    api.post(url, data)
    .then(response => {
      if (this.unmounted) {
        return;
      }
      const data = response.data;
      const pagination = data.pagination;
      const page = Number(pagination.page);
      const total = Number(pagination.total);
      const count = Number(pagination.count);

      const prevList = continues ? this.state.list : [];
      const list = [...prevList, ...data.list];
      const isLastPage = page === Math.ceil(total / count);
      this.setState({list, page, isLastPage});
    });
  }

  componentDidMount() {
    this.hasApprovalPermission = hasPermission(this.props.permissions.v_comments_approve);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.postId !== this.props.postId) {
      this.setState({list: []});
      this.fetch(false);
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    const {classes} = this.props;

    return (
      <div id="post-comments-wrapper">
        {this.state.list.length > 0 &&
          <div className={classes.titleLine}>
            <h3 className={classes.title}>
              <span className={classes.iconMessage}></span>دیدگاه&zwnj;ها
            </h3>
          </div>
        }

        {this.state.list.map(comment => {
          const data = {...comment, postId: this.props.postId};
          return <PostCommentsItem isAdmin={this.hasApprovalPermission} key={comment.id} data={data} />
        })}

        {(this.state.list.length > 0 && !this.state.isLastPage) &&
          <Button block text="بارگذاری موارد بیشتر" onClick={this.fetch} />
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  replyTo: state.replayTo,
  permissions: state.permissions,
});

const Component = connect(mapStateToProps)(withStyles(styles)(PostComments));
export {Component as PostComments};
export default Component;